import React from 'react';
import {
    COVER_DIM_ON_DARK,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const BoldBlock: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => (
    <div
        className="flex size-full flex-col justify-between px-[2.4em] py-[3em] text-white"
        style={{ backgroundColor: colors.primary }}
    >
        <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
        <div className="flex flex-col gap-[0.6em]">
            <div
                className="font-bold leading-[1.05] tracking-[-0.02em]"
                style={{ fontSize: coverTitleSize(2.4) }}
            >
                {fields.document_title}
            </div>
            {fields.subtitle ? (
                <div className="text-[0.82em]" style={{ color: COVER_DIM_ON_DARK }}>
                    {fields.subtitle}
                </div>
            ) : null}
        </div>
        <CoverMeta fields={fields} tone="dark" />
    </div>
);
